import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9 0a9 9 0 110 18A9 9 0 019 0zm0 1.385a7.615 7.615 0 100 15.23 7.615 7.615 0 000-15.23zM7.692 6.173a1 1 0 01.477.121l3.366 1.827a1 1 0 010 1.758L8.17 11.706a1 1 0 01-1.477-.879V7.173a1 1 0 011-1z",
		fillRule: "evenodd"
	})
});
export default SvgPlay;
